<svg xmlns="http://www.w3.org/2000/svg" width="21.205" height="21.205" viewBox="0 0 21.205 21.205">
    <path
        id="Icon_awesome-phone-alt"
        data-name="Icon awesome-phone-alt"
        d="M20.6,14.985,15.961,13a.994.994,0,0,0-1.16.286l-2.054,2.51A15.351,15.351,0,0,1,5.409,8.454L7.919,6.4A.992.992,0,0,0,8.2,5.24L6.217.6A1,1,0,0,0,5.078.025L.77,1.019A.994.994,0,0,0,0,1.988,19.215,19.215,0,0,0,19.217,21.205a.994.994,0,0,0,.969-.77l.994-4.307a1.006,1.006,0,0,0-.58-1.143Z"
        transform="translate(0 0)"
        fill="#8b8b8b"
    />
</svg>
